import React from 'react';
import PrintLayout from './PrintLayout';

const ROWS_PER_PAGE = 14;

function formatDur(ms) {
  if (!ms) return '0:00';
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

function chunk(arr, size) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) chunks.push(arr.slice(i, i + size));
  return chunks.length ? chunks : [[]];
}

export default function PrintTeamBreakdown({ pageNumber, reportData }) {
  const allSpeakers = reportData.participation?.speakers || [];
  const activeSpeakers = allSpeakers.filter(s => s.ms > 0).sort((a, b) => b.ms - a.ms);
  const silentSpeakers = allSpeakers.filter(s => s.ms === 0);
  const othersRow = silentSpeakers.length > 0 ? [{
    name: `Others (${silentSpeakers.length})`,
    ms: 0, minutes: 0, turns: 0, pct: 0, isOthers: true,
  }] : [];
  const speakers = [...activeSpeakers, ...othersRow];
  const inquiryPerPerson = reportData.inquiry?.perPerson || [];
  const freqMap = {};
  (reportData.frequency || []).forEach(f => { freqMap[f.speaker] = f.score; });

  const TH = { padding: '8px 12px', textAlign: 'left', fontWeight: 700, color: 'white', fontSize: 8.5, fontFamily: 'Montserrat, sans-serif' };
  const TD = { padding: '7px 12px', borderBottom: '1px solid rgba(42,61,91,0.12)', color: '#2a3d5b', fontSize: 9.5 };
  const TDC = { ...TD, textAlign: 'center' };

  const pages = chunk(speakers, ROWS_PER_PAGE);

  return pages.map((pageRows, pi) => (
    <PrintLayout key={pi} pageNumber={pi === 0 ? pageNumber : null}>
      <div style={{ position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, padding: '5% 6%', background: '#f5f4f0' }}>
        <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 24, fontWeight: 700, color: '#1e2e45', marginBottom: 18 }}>
          Team Breakdown{pi > 0 ? ' (cont.)' : ''}
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#1e2e45' }}>
              <th style={{ ...TH, width: '35%' }}>Name</th>
              <th style={{ ...TH, textAlign: 'center' }}>Comments</th>
              <th style={{ ...TH, textAlign: 'center' }}>Questions</th>
              <th style={{ ...TH, textAlign: 'center' }}>Turns</th>
              <th style={{ ...TH, textAlign: 'center' }}>Air Time</th>
            </tr>
          </thead>
          <tbody>
            {pageRows.map((p, i) => {
              if (p.isOthers) {
                return (
                  <tr key="others" style={{ background: i % 2 === 1 ? 'white' : undefined, opacity: 0.6 }}>
                    <td style={{ ...TD, fontStyle: 'italic' }}>{p.name}</td>
                    <td style={TDC}>—</td>
                    <td style={TDC}>—</td>
                    <td style={TDC}>—</td>
                    <td style={TDC}>No airtime</td>
                  </tr>
                );
              }
              const inq = inquiryPerPerson.find(x => x.name === p.name) || { advocacy: 0, inquiry: 0 };
              return (
                <tr key={p.name} style={{ background: i % 2 === 1 ? 'white' : undefined }}>
                  <td style={{ ...TD, fontWeight: 700 }}>{p.name.split('@')[0]}</td>
                  <td style={TDC}>{inq.advocacy}</td>
                  <td style={TDC}>{inq.inquiry}</td>
                  <td style={TDC}>{p.turns}</td>
                  <td style={TDC}>{formatDur(p.ms)} ({p.pct}%)</td>
                </tr>
              );
            })}
            {pageRows.length === 0 && (
              <tr>
                <td style={{ ...TD, fontStyle: 'italic', color: '#6b757e' }} colSpan={5}>No participation data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </PrintLayout>
  ));
}
